// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"0e030173","605":"6f57e71d","809":"62452d41","981":"3109c2b3"}[chunkId] + ".chunk.js";
};